/* ==========================================================================
   LEBONFLACON — Gouttes d'Or — Barre de progression panier (temps réel, v8)
   S'appuie sur /cart.js (API panier native Shopify) pour rester synchrone
   quel que soit le mécanisme du panier AJAX (ajout, suppression, quantité).
   La devise est toujours forcée en euros. 3 paliers : 70€ / 100€ / 150€.
   v8 : le premier palier devient le PACK BESTS-SELLERS OFFERT dès 70€.
   ========================================================================== */
(function () {
  'use strict';

  // Seuil technique : 2 × 34,99€. Le repère client reste affiché à 70€.
  var THRESHOLD_1 = 6998;
  var THRESHOLD_2 = 10000;
  var THRESHOLD_3 = 15000;
  var CELEBRATE_MS = 1500;

  function formatEuro(cents) {
    var c = Math.max(0, Math.round(cents));
    var value = (c / 100).toFixed(2).replace('.', ',');
    return value + ' €';
  }

  function offerSpan(size) {
    return '<strong class="lbf-cart-progress__offer">' + size + '&nbsp;ML&nbsp;<span>OFFERT</span></strong>';
  }

  function packSpan() {
    return '<strong class="lbf-cart-progress__offer">PACK BESTS-SELLERS&nbsp;<span>OFFERT</span></strong>';
  }

  function getActualGift(cart) {
    var result = { size: 0, pack: false };
    if (!cart || !cart.items) return result;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (Number(item.original_line_price) > Number(item.final_line_price) && Number(item.original_line_price) - Number(item.final_line_price) >= Number(item.original_price || item.price || 0)) {
        var title = String(item.product_title || item.title || '').toUpperCase();
        var handle = String(item.handle || '').toLowerCase();
        if (Number(item.product_id) === 4523867570309 || title.indexOf('PACK BESTS-SELLERS') !== -1 || title.indexOf('PACK DECOUVERTE') !== -1 || handle.indexOf('pack-decouverte') !== -1) {
          result.pack = true;
        }
        var m = /(\d+)\s*ML/i.exec(item.variant_title || item.title || '');
        if (m) {
          var size = parseInt(m[1], 10);
          if (size > result.size) result.size = size;
        }
      }
    }
    return result;
  }

  function buildMessage(tier, remaining1, remaining2, remaining3, gift, cartEmpty) {
    if(tier===0)return '🎁 Plus que <strong>'+formatEuro(cartEmpty?7000:remaining1)+'</strong> pour le Pack Découverte offert.';
    if(tier===1)return (gift.pack?'🎁 Pack Découverte offert.':'🎁 Pack Découverte débloqué.')+'<br>Plus que <strong>'+formatEuro(remaining2)+'</strong> pour le 50 ml offert.';
    var size=tier===3?100:50;
    var message=gift.size===size?'🎁 Votre cadeau : '+offerSpan(size)+'.':'🎁 '+offerSpan(size)+' débloqué. Choisissez votre parfum ci-dessous.';
    if(tier===2)message+='<br>Plus que <strong>'+formatEuro(remaining3)+'</strong> pour le 100 ml offert.';
    return message;
  }

  function spawnConfetti(markerEl) {
    if (!markerEl || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#c9a96e', '#e3c689', '#9c7a3e', '#ffffff'];
    var burst = document.createElement('span');
    burst.className = 'lbf-confetti-burst';
    for (var i = 0; i < 14; i++) {
      var piece = document.createElement('span');
      piece.className = 'lbf-confetti-piece';
      piece.style.setProperty('--lbf-c-angle', (Math.random() * 360) + 'deg');
      piece.style.setProperty('--lbf-c-dist', (30 + Math.random() * 40) + 'px');
      piece.style.setProperty('--lbf-c-delay', (Math.random() * 0.15) + 's');
      piece.style.background = colors[i % colors.length];
      burst.appendChild(piece);
    }
    markerEl.appendChild(burst);
    window.setTimeout(function () {
      if (burst.parentNode) burst.parentNode.removeChild(burst);
    }, 1200);
  }

  function renderBar(el, cart) {
    var state = window.LBFGiftRules ? window.LBFGiftRules.inspect(cart) : null;
    var total = state ? state.total : cart.total_price;
    var gift = getActualGift(cart);
    var t1 = parseInt(el.getAttribute('data-threshold-1'), 10) || THRESHOLD_1;
    var t2 = parseInt(el.getAttribute('data-threshold-2'), 10) || THRESHOLD_2;
    var t3 = parseInt(el.getAttribute('data-threshold-3'), 10) || THRESHOLD_3;
    var pct = Math.max(0, Math.min(100, (total / t3) * 100));

    var tier = 0;
    if (total >= t3) tier = 3;
    else if (total >= t2) tier = 2;
    else if (total >= t1) tier = 1;

    if (state && state.tier > tier) tier = state.tier;

    var prevTier = parseInt(el.getAttribute('data-lbf-tier'), 10);
    if (isNaN(prevTier)) prevTier = 0;

    var fill = el.querySelector('[data-lbf-fill]');
    var msg = el.querySelector('[data-lbf-message]');
    if (fill) fill.style.width = pct + '%';

    el.classList.remove('is-tier1', 'is-complete');
    if (tier === 3) el.classList.add('is-complete');
    else if (tier > 0) el.classList.add('is-tier1');

    var remaining1 = state && state.packEligible ? 0 : Math.max(0, t1 - (state ? state.subtotal : total));
    var remaining2 = Math.max(0, t2 - total);
    var remaining3 = Math.max(0, t3 - total);
    if (msg) msg.innerHTML = buildMessage(tier, remaining1, remaining2, remaining3, gift, !cart.item_count);

    var m1 = el.querySelector('.lbf-cart-progress__marker--1');
    var m2 = el.querySelector('.lbf-cart-progress__marker--2');
    var m3 = el.querySelector('.lbf-cart-progress__marker--3');
    if (m1) m1.classList.toggle('is-reached', tier >= 1);
    if (m2) m2.classList.toggle('is-reached', tier >= 2);
    if (m3) m3.classList.toggle('is-reached', tier >= 3);

    if (tier > prevTier) {
      el.classList.add('lbf-cart-progress--celebrate');
      var markers = [null, m1, m2, m3];
      var justUnlocked = markers[tier];
      if (justUnlocked) {
        justUnlocked.classList.add('is-celebrating');
        spawnConfetti(justUnlocked);
      }
      if (msg) {
        msg.classList.add('is-pulsing');
        window.setTimeout(function () { msg.classList.remove('is-pulsing'); }, 700);
      }
      if (window.navigator && typeof window.navigator.vibrate === 'function') {
        try { window.navigator.vibrate([25, 40, 25]); } catch (e) {}
      }
      window.setTimeout(function () {
        el.classList.remove('lbf-cart-progress--celebrate');
        if (justUnlocked) justUnlocked.classList.remove('is-celebrating');
      }, CELEBRATE_MS);
    }

    el.setAttribute('data-lbf-tier', String(tier));
  }

  function updateAllBars(cart) {
    var bars = document.querySelectorAll('[data-lbf-cart-progress]');
    if (!bars.length) return;
    for (var i = 0; i < bars.length; i++) {
      renderBar(bars[i], cart);
    }
  }

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && (event.detail.cart || event.detail);
    if (cart && Array.isArray(cart.items)) updateAllBars(cart);
  });

  var refreshTimer = null;
  function refreshFromServer() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateAllBars(cart); })
        .catch(function () {});
    }, 150);
  }

  var CART_ENDPOINT_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var result = originalFetch.apply(this, arguments);
      try {
        var target = arguments[0];
        var url = (target && target.url) || target || '';
        if (typeof url === 'string' && CART_ENDPOINT_RE.test(url)) {
          result.then(function () { refreshFromServer(); });
        }
      } catch (e) {}
      return result;
    };
  }

  if (window.XMLHttpRequest) {
    var originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && CART_ENDPOINT_RE.test(url)) {
          this.addEventListener('loadend', refreshFromServer);
        }
      } catch (e) {}
      return originalOpen.apply(this, arguments);
    };
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest(
      '.ajaxifyCart--add, .ajaxifyCart--minus, .js--add, .js--minus, ' +
      '.cart-toggle, .update-cart, .quantity-selector, .addToCart, .remove'
    );
    if (t) refreshFromServer();
  });

  document.addEventListener('change', function (e) {
    var t = e.target.closest && e.target.closest(
      '.ajaxifyCart--num, .js--num, .cart__quantity-selector, .quantity-selector'
    );
    if (t) refreshFromServer();
  });

  document.addEventListener('submit', function (e) {
    var t = e.target.closest && e.target.closest('.addToCartForm, .cart-form');
    if (t) refreshFromServer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshFromServer);
  } else {
    refreshFromServer();
  }
})();

